/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Vladislav Oshkanov
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.15.0
 * @since 1.0.0
 */

import React from 'react';

import invoke from 'lodash/invoke';

import { icons } from '../../../assets';
import withDefaultProps from '../../../modules/app/hoc/withDefaultProps';
import { IAttrStyled } from '../../../types/globalTypes';
import { BlockWithIcon, LinkBlock } from '../index';
import { DropContainerStyled } from './styled/DropFiltersButton';

export interface IDropFiltersButtonProps extends IAttrStyled {
    label: string;
    onClick: () => void;
}

const defaultProps: IDropFiltersButtonProps = {
    label: '',
    onClick: () => {
    },
};

export const DropFiltersButton = (props: IDropFiltersButtonProps) => {
    const linkHandler = (event?: React.MouseEvent) => {
        invoke(event, 'stopPropagation');
        props.onClick();
    };
    return (
        <DropContainerStyled
            className="drop-filters-button"
            data-name={props.dataName}
            onClick={props.onClick}
        >
            <BlockWithIcon
                iconLeft={icons.cancelBlueSmallIcon}
                iconLeftSize={10}
            >
                <LinkBlock className="drop-filters-button__link" onClick={linkHandler}>{props.label}</LinkBlock>
            </BlockWithIcon>
        </DropContainerStyled>
    );
};

export default withDefaultProps(defaultProps, DropFiltersButton);
